import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { MarginType } from "types/MarginTypes";

export default function useGetMargins() {
  return useQuery({
    queryKey: ["margins"],
    queryFn: async () => {
      return axiosInstance.get(`/margins`).then((res) => res.data);
    },
    select: (data: MarginType[]) => data,
    retry: false,
  });
}
